import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-003e2b28"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "absolute inset-0 bg-white opacity-60",
  style: {"z-index":"9999"}
}
const _hoisted_2 = { class: "border-b pt-2 pb-4 my-3 border-gray-500" }
const _hoisted_3 = { class: "whitespace-nowrap rounded-lg px-2 py-0.5 my-1 text-sm text-white font-normal plannedBg" }
const _hoisted_4 = { class: "flex text-sm text-gray-600 font-normal" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "px-1" }, "-", -1))
const _hoisted_6 = { class: "ml-1" }
const _hoisted_7 = {
  key: 1,
  class: "py-1 flex items-center gap-1 justify-between flex-wrap"
}
const _hoisted_8 = { class: "whitespace-nowrap rounded-lg px-2 py-0.5 my-1 text-sm text-white font-normal bg-green" }
const _hoisted_9 = { class: "flex gap-3 items-center" }
const _hoisted_10 = {
  key: 0,
  class: "flex text-sm text-gray-600 font-normal"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "px-1" }, "-", -1))
const _hoisted_12 = { class: "ml-1" }
const _hoisted_13 = {
  key: 1,
  class: "flex text-sm text-gray-600 font-normal items-center"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "px-2" }, "-", -1))
const _hoisted_15 = { class: "flex gap-2" }
const _hoisted_16 = {
  key: 2,
  class: "flex justify-center mt-2"
}
const _hoisted_17 = {
  key: 3,
  class: "flex justify-end gap-2 items-center mt-2"
}
const _hoisted_18 = { class: "text-xs" }
const _hoisted_19 = { class: "py-4" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "flex justify-between items-center" }
const _hoisted_22 = { class: "font-bold text-md" }
const _hoisted_23 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSection = _resolveComponent("LoadingSection")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_PencilIcon = _resolveComponent("PencilIcon")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_OaiSwitch = _resolveComponent("OaiSwitch")!
  const _component_PlannerComments = _resolveComponent("PlannerComments")!
  const _component_ArrowDownTrayIcon = _resolveComponent("ArrowDownTrayIcon")!
  const _component_ImagesComparison = _resolveComponent("ImagesComparison")!
  const _component_GalleryDownload = _resolveComponent("GalleryDownload")!
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")!
  const _component_SlideOver = _resolveComponent("SlideOver")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_LoadingSection, { loading: _ctx.loading }, null, 8, ["loading"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_SlideOver, {
      open: _ctx.open,
      onClosed: _cache[9] || (_cache[9] = ($event: any) => (!_ctx.isConfirmationModalOpen && !_ctx.galleryDownloadModalOpen && _ctx.$emit('closed'))),
      maxWidth: "1000px"
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.resourceFullName), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.plannedEvent)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "py-1 flex items-center gap-1 justify-between flex-wrap",
                style: _normalizeStyle(_ctx.actualEvent && 'margin-right: 1.75rem')
              }, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("analytics.planner.target_period")), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.format(_ctx.plannedEvent.getData("startDate"), "dd.MM.yyyy")), 1),
                  _hoisted_5,
                  _createElementVNode("span", null, _toDisplayString(_ctx.format(_ctx.plannedEvent.getData("endDate"), "dd.MM.yyyy")), 1),
                  _createElementVNode("span", _hoisted_6, " (" + _toDisplayString(`${_ctx.formatNumber(_ctx.getWorkingDays(_ctx.plannedEvent))} ${_ctx.$t(
                  "analytics.planner.working_days_label",
                  _ctx.getWorkingDays(_ctx.plannedEvent),
                )}`) + ") ", 1)
                ])
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.actualEvent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("analytics.planner.actual_period")), 1),
                _createElementVNode("div", _hoisted_9, [
                  (!_ctx.editMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.actualEvent.getData("startDate")
                    ? _ctx.format(_ctx.actualEvent.getData("startDate"), "dd.MM.yyyy")
                    : ""), 1),
                        _hoisted_11,
                        _createElementVNode("span", null, _toDisplayString(_ctx.actualEvent.getData("active")
                    ? _ctx.$t("analytics.planner.present")
                    : _ctx.actualEvent.getData("endDate")
                    ? _ctx.format(_ctx.actualEvent.getData("endDate"), "dd.MM.yyyy")
                    : ""), 1),
                        _createElementVNode("span", _hoisted_12, " (" + _toDisplayString(`${_ctx.formatNumber(_ctx.getWorkingDays(_ctx.actualEvent))} ${_ctx.$t(
                    "analytics.planner.working_days_label",
                    _ctx.getWorkingDays(_ctx.actualEvent),
                  )}`) + ") ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.editMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(_component_VueDatePicker, {
                          "input-class-name": "!text-xs",
                          class: "w-36",
                          modelValue: _ctx.newStartTime,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newStartTime) = $event)),
                          "enable-time-picker": false,
                          format: "dd.MM.yyyy",
                          locale: _ctx.$i18n.locale,
                          "auto-apply": "",
                          "reverse-years": "",
                          clearable: false
                        }, null, 8, ["modelValue", "locale"]),
                        _hoisted_14,
                        _createVNode(_component_VueDatePicker, {
                          "input-class-name": "!text-xs",
                          class: "w-36",
                          modelValue: _ctx.newEndTime,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newEndTime) = $event)),
                          "enable-time-picker": false,
                          format: "dd.MM.yyyy",
                          locale: _ctx.$i18n.locale,
                          "auto-apply": "",
                          "reverse-years": "",
                          disabled: !_ctx.isActualCompleted,
                          clearable: false
                        }, null, 8, ["modelValue", "locale", "disabled"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_15, [
                    (!_ctx.editMode)
                      ? (_openBlock(), _createBlock(_component_PencilIcon, {
                          key: 0,
                          class: _normalizeClass([
                  'h-4 w-4 cursor-pointer transition-colors duration-200',
                  _ctx.isActualProcessing
                    ? 'text-gray-300 hover:text-gray-300'
                    : 'text-gray-400 hover:text-gray-600',
                ]),
                          onClick: _ctx.setEditMode
                        }, null, 8, ["class", "onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock(_component_CheckIcon, {
                          key: 1,
                          class: _normalizeClass([
                  'h-4 -600 cursor-pointer transition-colors duration-200',
                  _ctx.isActualProcessing
                    ? 'text-gray-300 hover:text-gray-300'
                    : '-4 text-gray-400 hover:text-green',
                ]),
                          onClick: _ctx.handleActualUpdate
                        }, null, 8, ["class", "onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock(_component_XMarkIcon, {
                          key: 2,
                          class: _normalizeClass([
                  'h-4 w-4 cursor-pointer transition-colors duration-200',
                  _ctx.isActualProcessing
                    ? 'text-gray-300 hover:text-gray-300'
                    : 'text-gray-400 hover:text-gray-600',
                ]),
                          onClick: _ctx.disableEditMode
                        }, null, 8, ["class", "onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock(_component_TrashIcon, {
                          key: 3,
                          class: _normalizeClass([
                  'h-4 w-4 cursor-pointer transition-colors duration-200',
                  _ctx.isActualProcessing
                    ? 'text-gray-300 hover:text-gray-300'
                    : 'text-gray-400 hover:text-red-600',
                ]),
                          onClick: _ctx.handleActualDelete
                        }, null, 8, ["class", "onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleAddActual && _ctx.handleAddActual(...args))),
                  class: "flex items-center gap-1 rounded bg-yellow-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-yellow-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600"
                }, [
                  _createVNode(_component_PlusIcon, { class: "h-5 w-5" }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("analytics.planner.add_actual_event")), 1)
                ])
              ])),
          (_ctx.editMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.isActualCompleted
              ? _ctx.$t("analytics.planner.actual_finished")
              : _ctx.$t("analytics.planner.actual_active")), 1),
                _createVNode(_component_OaiSwitch, {
                  modelValue: _ctx.isActualCompleted,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isActualCompleted) = $event))
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(), _createBlock(_component_PlannerComments, {
            sourceId: _ctx.sourceId,
            key: _ctx.plannerCommentsKey,
            onConfirmationModalIsOpen: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isConfirmationModalOpen = true)),
            onConfirmationModalIsClosed: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isConfirmationModalOpen = false)),
            onCommentAdded: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('commentAdded', $event))),
            onCommentDeleted: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('commentDeleted', $event)))
          }, null, 8, ["sourceId"]))
        ]),
        (_ctx.cameraList.length && _ctx.actualEvent?.getData('id'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cameraList, (camera) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: camera,
                  class: "my-6 border-t py-4"
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("h2", _hoisted_22, _toDisplayString(_ctx.$t("app_features.compare")), 1),
                    _createElementVNode("button", {
                      onClick: ($event: any) => {
                _ctx.galleryDownloadStreamsToInitialze = [camera];
                _ctx.galleryDownloadModalOpen = true;
              }
                    }, [
                      _createVNode(_component_ArrowDownTrayIcon, { class: "h-6" })
                    ], 8, _hoisted_23)
                  ]),
                  _createVNode(_component_ImagesComparison, {
                    camera: camera,
                    initialAfterDate: _ctx.initialAfterDate,
                    initialBeforeDate: _ctx.initialBeforeDate,
                    hideNoImageToast: ""
                  }, null, 8, ["camera", "initialAfterDate", "initialBeforeDate"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.galleryDownloadModalOpen)
          ? (_openBlock(), _createBlock(_component_GalleryDownload, {
              key: 1,
              streamsToInitialize: _ctx.galleryDownloadStreamsToInitialze,
              dateRangeToInitialize: 
          _ctx.initialBeforeDate && _ctx.initialAfterDate ? [_ctx.initialBeforeDate, _ctx.initialAfterDate] : undefined
        ,
              onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.galleryDownloadModalOpen = false))
            }, null, 8, ["streamsToInitialize", "dateRangeToInitialize"]))
          : _createCommentVNode("", true),
        _createVNode(_component_ConfirmationModal, { ref: "confirmationModal" }, null, 512)
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}